import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/services/auth.service';

declare let gtag: Function;
const lang: string = 'pt';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(
        private router: Router,
        private config: PrimeNGConfig,
        private translateService: TranslateService,
        private authService: AuthService
    ) {
        translateService.addLangs([lang]);
        this.translateService.setDefaultLang(lang);

        this.translateService.use(lang);
        this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));

        // registra no Google Analytics os acessos a cada rota pelos usuários
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {

                gtag('config', 'G-041L76K2MJ', { 'page_path': event.urlAfterRedirects });
            }
        });
    }

    ngOnInit() {
        this.checkLogoutParam();
      (window as any).abrirModalSenha = () => {
        try {
          window.dispatchEvent(new Event('abrirModalSenha'));
        } catch (exception) {
            console.error('Ocorreu um erro ao abrir o modal de senha:', exception);
        }
      };
      }
    
      ngAfterViewInit() {
        this.router.events.subscribe(event => {
          if (event instanceof NavigationStart) {
            this.checkLogoutParam();
          }
        });
      }
    
      private checkLogoutParam(): void {
        const urlFragment = window.location.hash;
        const urlParams = new URLSearchParams(urlFragment.split('?')[1]);
    
        if (urlParams.has('logout') && urlParams.get('logout') === 'true') {
          this.authService.doLogout().subscribe(() => {
            this.router.navigate(['/logon']);
          });
        }
      }

    // @HostListener('document:mouseleave', ['$event'])
    // onMouseLeave(event) {

    //   const disableProductOffer = localStorage.getItem('gsp_disable_product_offer') === 'true';
    //   if (disableProductOffer || this.dialogRef !== null || this.authService.token) {
    //     return;
    //   }

    //   this.dialogRef = this.dialog.open(ProductOfferComponent, {
    //     panelClass: 'product-offer-popup'
    //   });

    //   this.dialogRef.afterClosed().subscribe(r => {
    //     localStorage.setItem('gsp_disable_product_offer', r);
    //     this.dialogRef = null;
    //   });
    // }
}
